class FabricSwatchesSidebar extends HTMLElement {
  constructor() {
    super();

    gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);
  }

  connectedCallback() {
    this.sidebar = this.querySelector('.fabric-swatches-sidebar__inner');
    this.listWrapper = this.querySelector('.js-swatch-list');
    this.items = document.querySelectorAll('fabric-swatches');
    this.links = [];

    this.items.forEach((item) => {
      const title = item.getAttribute('data-title');
      const imgSrc = item.getAttribute('data-thumb');
      const anchor = item.getAttribute('data-anchor-id');

      this.createItem(title, imgSrc, anchor);
    });

    this.setup();
    this.overrideLinkClicks();
  }

  createItem(title, imgSrc, anchor) {
    const li = document.createElement('li');
    li.classList.add('scroll-trigger');
    li.classList.add('animate--slide-in');

    const a = document.createElement('a');
    a.classList.add('fabric-swatches-sidebar__link');
    a.setAttribute('href', anchor);

    const svg =
      '<svg viewBox="0 0 6 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 4L1.50571e-07 7.4641L4.53412e-07 0.535898L6 4Z" fill="#232323"/></svg>';

    const img = document.createElement('img');
    img.setAttribute('src', imgSrc);
    img.setAttribute('alt', title);
    img.setAttribute('width', 120);

    const span = document.createElement('span');
    span.classList.add('ui-standard');
    span.innerHTML = title;

    a.innerHTML = svg;
    a.appendChild(img);
    a.appendChild(span);

    li.appendChild(a);

    this.listWrapper.appendChild(li);

    this.links.push(a);
  }

  refreshTriggers() {
    ScrollTrigger.refresh();
  }

  setup() {
    let mm = gsap.matchMedia();

    mm.add('(min-width: 1240px)', () => {
      ScrollTrigger.create({
        trigger: this.sidebar,
        start: 'top top',
        end: () => {
          const start = this.items[0].getBoundingClientRect().top;
          const end = this.items[this.items.length - 1].getBoundingClientRect().bottom;
          const height = end - start - window.innerHeight / 2;

          return `${height}px`;
        },
        pin: true,
      });

      this.items.forEach((item, itemIndex) => {
        ScrollTrigger.create({
          trigger: item,
          start: 'top 50%',
          end: `bottom 50%`,
          onToggle: (self) => {
            if (self.isActive) {
              this.links[itemIndex].classList.add('active');
            } else {
              this.links[itemIndex].classList.remove('active');
            }
          },
        });
      });

      window.addEventListener('resize', this.refreshTriggers);

      return () => {
        window.removeEventListener('resize', this.refreshTriggers);
      };
    });
  }

  overrideLinkClicks() {
    this.links.forEach((link) => {
      link.addEventListener('click', (e) => {
        e.preventDefault();

        const target = document.querySelector(link.getAttribute('href'));

        gsap.to(window, {
          duration: 1,
          scrollTo: target,
          ease: 'power3.inOut',
        });
      });
    });
  }
}

customElements.define('fabric-swatches-sidebar', FabricSwatchesSidebar);
